import cx from "classnames";
import styles from "./SectionHeading.module.scss";

const SectionHeadingSecondaryLink = ({
  url,
  analyticsSlug,
  secondaryLinkText,
}: {
  url: string;
  analyticsSlug: string;
  secondaryLinkText: string;
}) => {
  return (
    <a
      className={styles.secondaryLink}
      href={url}
      data-action={`click link - ${analyticsSlug} - ${secondaryLinkText}`}
    >
      {secondaryLinkText}
    </a>
  );
};

const SectionHeading = ({
  title,
  url,
  analyticsSlug,
  secondaryLinkText,
}: {
  title: string;
  url: string;
  analyticsSlug: string;
  secondaryLinkText?: string;
}) => {
  return (
    <div className={cx(styles.root, secondaryLinkText && styles.grid)}>
      <h3 className={styles.heading}>
        <a
          className={styles.headingLink}
          data-action={`click link - ${analyticsSlug} - header`}
          href={url}
        >
          {title}
        </a>
      </h3>
      {secondaryLinkText && (
        <SectionHeadingSecondaryLink
          url={url}
          analyticsSlug={analyticsSlug}
          secondaryLinkText={secondaryLinkText}
        />
      )}
    </div>
  );
};

export default SectionHeading;
